// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38H1E","title":"styles_title__2rLtH"};